import { Controller } from "@hotwired/stimulus";

// Shows the values of a step of the bonus curve (BonusSettingsHelper#bonus_chart) above the hovered,
// focused or tapped step.
export default class extends Controller {
  static targets = ["tooltip", "zone"];

  show(event) {
    const zone = event.currentTarget;
    const plot = this.tooltipTarget.parentElement;

    this.zoneTargets.forEach((other) => other.classList.toggle("bonus-chart__zone--active", other === zone));
    this.tooltipTarget.textContent = zone.dataset.label;
    this.tooltipTarget.classList.add("bonus-chart__tooltip--visible");

    // Centered above the step, kept inside the chart
    const width = this.tooltipTarget.offsetWidth;
    const center = zone.offsetLeft + zone.offsetWidth / 2;
    const left = Math.min(Math.max(center - width / 2, 0), plot.clientWidth - width);
    this.tooltipTarget.style.left = `${left}px`;
  }

  hide(event) {
    event.currentTarget.classList.remove("bonus-chart__zone--active");
    this.tooltipTarget.classList.remove("bonus-chart__tooltip--visible");
  }
}
